import { render } from "./PublicAside.vue?vue&type=template&id=55f305f8&scoped=true&ts=true"
import script from "./PublicAside.vue?vue&type=script&lang=ts"
export * from "./PublicAside.vue?vue&type=script&lang=ts"

import "./PublicAside.vue?vue&type=style&index=0&id=55f305f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f305f8"],['__file',"src/components/aside/PublicAside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55f305f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55f305f8', __exports__)) {
    api.reload('55f305f8', __exports__)
  }
  
  module.hot.accept("./PublicAside.vue?vue&type=template&id=55f305f8&scoped=true&ts=true", () => {
    api.rerender('55f305f8', render)
  })

}


export default __exports__